import React from 'react';
import { Button } from 'antd';
import { updatePageReady } from '../../Utils/SupabaseServices/UserDatabase';

interface DashboardReadyModalProps {
  username?: string;
  onClose: () => void;
}

const DashboardReadyModal: React.FC<DashboardReadyModalProps> = ({ username, onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'rgba(0, 0, 0, 0.4)',
      backdropFilter: 'blur(10px)'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '16px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        maxWidth: '550px',
        width: '90%',
        position: 'relative',
        animation: 'slideDown 0.5s ease-out'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{
            width: '64px',
            height: '64px',
            background: '#ecfdf5',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
          }}>
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#10b981"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
            </svg>
          </div>
          <h2 style={{
            color: '#111827',
            fontSize: '1.875rem',
            fontWeight: '700',
            marginBottom: '12px'
          }}>
            Your Dashboard is Ready!
          </h2>
        </div>

        <div style={{
          color: '#4b5563',
          fontSize: '1.1rem',
          lineHeight: '1.6',
          textAlign: 'center'
        }}>
          <p style={{ marginBottom: '24px' }}>
            {username ? `Great news, ${username}! ` : ''}
            Your dashboard has been fully loaded with all your latest data and insights. 
            You're all set to explore and analyze your metrics.
          </p>

          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
            <Button
              type="primary"
              onClick={async () => {
                onClose();
                if (username) {
                  await updatePageReady(username);
                }
              }}
              size="large"
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
      <style>
        {`
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
};

export default DashboardReadyModal; 